const ROUTES = {
    DETAILS: 'DETAILS',
    LIVE_MATCHES: 'LIVE_MATCHES',
    TOURNAMENT_LISTING: 'TOURNAMENT_LISTING',
    MY_TOURNAMENTS: 'MY_TOURNAMENTS',
    VIEW_TOURNAMENT: 'VIEW_TOURNAMENT',
}

export { ROUTES }